export const FETCH_INVITATIONS = "FETCH_INVITATIONS";
export const FETCH_INVITATIONS_SUCCESS = "FETCH_INVITATIONS_SUCCESS";
export const FETCH_INVITATIONS_FAIL = "FETCH_INVITATIONS_FAIL";

export const ACCEPT_INVITATION = "ACCEPT_INVITATION";
export const ACCEPT_INVITATION_SUCCESS = "ACCEPT_INVITATION_SUCCESS";
export const ACCEPT_INVITATION_FAIL = "ACCEPT_INVITATION_FAIL";

export const REJECT_INVITATION = "REJECT_INVITATION";
export const REJECT_INVITATION_SUCCESS = "REJECT_INVITATION_SUCCESS";
export const REJECT_INVITATION_FAIL = "REJECT_INVITATION_FAIL";
